function paSetImg(btn,url){
  var img=document.getElementById('pa-pdp-main-img');
  if(img){img.src=url;img.removeAttribute('srcset');}
  document.querySelectorAll('.pa-pdp-thumb').forEach(function(t){t.classList.remove('is-active');});
  btn.classList.add('is-active');
}
function paQty(d){
  var inp=document.getElementById('pa-qty');
  if(!inp)return;
  var v=parseInt(inp.value||'1')+d;
  inp.value=Math.max(1,v);
}
function paSyncPriceToTier(tier){
  if(!tier) return;
  var nowEl = document.getElementById('pa-pdp-now');
  var wasEl = document.getElementById('pa-pdp-was');
  var offEl = document.getElementById('pa-pdp-off');
  var priceNow = tier.getAttribute('data-price-now');
  var priceWas = tier.getAttribute('data-price-was');
  var discPct = parseFloat(tier.getAttribute('data-discount-pct') || '0');
  if(nowEl && priceNow) nowEl.textContent = priceNow;
  if(wasEl){
    if(priceWas && discPct > 0){ wasEl.textContent = priceWas; wasEl.hidden = false; }
    else { wasEl.hidden = true; }
  }
  if(offEl){
    if(discPct > 0){ offEl.textContent = discPct + '% OFF'; offEl.hidden = false; }
    else { offEl.hidden = true; }
  }
}
document.addEventListener('click', function(e){
  var tier = e.target.closest('[data-pa-tier]');
  if(!tier) return;
  document.querySelectorAll('.pa-tier').forEach(function(t){t.classList.remove('is-selected');});
  tier.classList.add('is-selected');
  var radio = tier.querySelector('input[type="radio"]');
  if(radio) radio.checked = true;
  var qtyInput = document.getElementById('pa-qty');
  if(qtyInput) qtyInput.value = tier.getAttribute('data-qty');
  paSyncPriceToTier(tier);
});
document.addEventListener('DOMContentLoaded', function(){
  var selected = document.querySelector('.pa-tier.is-selected[data-pa-tier]');
  if(selected) paSyncPriceToTier(selected);
});

/* ---- Sticky Add to Cart bar ---- */
(function(){
  var bar = document.getElementById('pa-sticky-atc');
  var anchor = document.getElementById('pa-pdp-qty-cta');
  var stickyBtn = document.getElementById('pa-sticky-atc-btn');
  var stickyQtyVal = document.getElementById('pa-sticky-qty-val');
  var stickyMinus = document.getElementById('pa-sticky-qty-minus');
  var stickyPlus = document.getElementById('pa-sticky-qty-plus');
  if(!bar || !anchor) return;

  function revealStickyBar(){
    bar.hidden = false;
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ bar.classList.add('is-visible'); });
    });
  }
  function hideStickyBar(){
    bar.classList.remove('is-visible');
  }

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting){
          revealStickyBar();
        } else {
          hideStickyBar();
        }
      });
    }, { threshold: 0, rootMargin: '-120px 0px -120px 0px' });
    io.observe(anchor);
  } else {
    revealStickyBar();
  }

  function syncStickyQtyDisplay(){
    if(!stickyQtyVal) return;
    var mainQtyInput = document.getElementById('pa-qty');
    if(mainQtyInput) stickyQtyVal.textContent = mainQtyInput.value || '1';
  }
  if(stickyMinus){
    stickyMinus.addEventListener('click', function(){ paQty(-1); syncStickyQtyDisplay(); });
  }
  if(stickyPlus){
    stickyPlus.addEventListener('click', function(){ paQty(1); syncStickyQtyDisplay(); });
  }
  syncStickyQtyDisplay();

  if(stickyBtn){
    stickyBtn.addEventListener('click', function(){
      var realBtn = document.querySelector('#pa-pdp-form .pa-pdp-atc');
      if(realBtn) realBtn.click();
    });
  }
})();
